import { createContext } from 'react';

const LevelContext = createContext(0);

export { LevelContext };
